{
  "name": "12-Pythagorean (pure fifths)",
  "description": "12-tone 3-Limit Rational Intonation (JI) scale. Derived from harmonic partial row intervals, it is limited to partials having only 2 and 3 as prime factors. Traditionally attributed to Pythagoras and the Pythagoreans, this tuning is also described in Ancient Mesopotamian / Akkadian and Chinese music texts, and remains in use today. A sequence of eleven perfect fifths - from D♭ through F♯ - are tuned as pure 2:3 ratios. The missing 13th note C♯ would lie one Tertial (Pythagorean) Comma (ca. 23.5 cents) higher than the D♭. Four diminished fourths – A-D♭, E-A♭, B-E♭, F♯-B♭ – are nearly pure – one schisma (ca. 2 cents) less than 4:5 ratios.",
  "scale": [
    "256/243",
    "9/8",
    "32/27",
    "81/64",
    "4/3",
    "729/512",
    "3/2",
    "128/81",
    "27/16",
    "16/9",
    "243/128",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "12-JI-3L_Pythag",
  "built_in_group": "12 Note Scales",
  "key_labels": "note_names",
  "note_names": ["C", "D", "D", "E", "E", "F", "F", "G", "A", "A", "B", "B"],
  "note_colors": [
    "#ffcbcb",
    "#d0d0d7",
    "#ffffff",
    "#d0d0d7",
    "#ffffff",
    "#ffffff",
    "#dee2da",
    "#ffffff",
    "#d0d0d7",
    "#ffffff",
    "#d0d0d7",
    "#ffffff"
  ],
  "equivSteps": 12,
  "fundamental": 440,
  "reference_degree": 9,
  "center_degree": 0,
  "rSteps": 2,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751
}
